<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <!-- 顶部门店选择（外卖设置按门店分组存储） -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="8" :sm="24">
                <a-form-item label="所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="storeId" placeholder="请选择门店" @change="onStoreChange">
                    <a-select-option v-for="s in storeOptionList" :key="s.id" :value="s.id">{{ s.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-tabs v-model="activeTab">
          <!-- ============ Tab1 外卖设置（克隆云贝 #/storeoutset Tab1） ============ -->
          <a-tab-pane tab="外卖设置" key="takeout">
            <a-form class="setting-form">
              <a-form-item label="营业时间" :labelCol="formLabelCol" :wrapperCol="formWrapperCol" required>
                <a-radio-group v-model="form.timeType">
                  <a-radio value="1">全天24小时营业</a-radio>
                  <a-radio value="2">设置营业时间</a-radio>
                </a-radio-group>
                <div v-if="form.timeType === '2'" class="time-rows">
                  <div v-for="(item, index) in timeArr" :key="index" class="time-row">
                    <a-time-picker
                      :value="toMoment(item.startTime)"
                      format="HH:mm"
                      :minute-step="5"
                      :allow-clear="false"
                      placeholder="选择时间"
                      style="width: 150px"
                      @change="(t, val) => onTimeChange(item, 'startTime', val)" />
                    <span class="time-sep">-</span>
                    <span v-if="item.ciri" class="time-ciri">次日</span>
                    <a-time-picker
                      :value="toMoment(item.endTime)"
                      format="HH:mm"
                      :minute-step="5"
                      :allow-clear="false"
                      placeholder="选择时间"
                      style="width: 150px"
                      @change="(t, val) => onTimeChange(item, 'endTime', val)" />
                    <a class="time-del" @click="delTimeInterval(index)">删除</a>
                  </div>
                  <a-button v-show="timeArr.length < 3" type="link" icon="plus" @click="addTimeInterval">添加营业时间</a-button>
                </div>
              </a-form-item>
              <a-form-item label="商家公告" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-textarea v-model="form.notice" placeholder="请输入商家公告" :rows="3" />
              </a-form-item>
              <a-form-item label="下单公告" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-textarea v-model="form.orderNotice" placeholder="请输入下单公告" :rows="3" />
              </a-form-item>
              <a-form-item label="下单幻灯片" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <j-image-upload v-model="form.orderMedia" bizPath="material" text="上传幻灯片" isMultiple />
              </a-form-item>
              <a-form-item label="配送支持" :labelCol="formLabelCol" :wrapperCol="formWrapperCol" required>
                <a-checkbox-group v-model="form.distributionSupport">
                  <a-checkbox value="1">外卖配送</a-checkbox>
                  <a-checkbox value="2">到店自提</a-checkbox>
                </a-checkbox-group>
              </a-form-item>
              <!-- 联动：勾选"到店自提"→ 显示消费方式/预留手机/自提地址/经纬度/地图定位 -->
              <div v-if="form.distributionSupport.indexOf('2') > -1">
                <a-form-item label="消费方式" :labelCol="formLabelCol" :wrapperCol="formWrapperCol" required>
                  <a-checkbox-group v-model="form.diningType">
                    <a-checkbox value="1">店内就餐</a-checkbox>
                    <a-checkbox value="2">打包带走</a-checkbox>
                  </a-checkbox-group>
                </a-form-item>
                <a-form-item label="预留手机" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <a-radio-group v-model="form.reserveTelOpen">
                    <a-radio value="1">开启</a-radio>
                    <a-radio value="2">关闭</a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-form-item label="自提地址" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <!-- 地址栏直接搜索（无省市区字段，地址原样搜），云贝交互 -->
                  <span class="addr-search-row">
                    <a-input
                      v-model="form.address"
                      placeholder="请输入地址（回车或点搜索定位）"
                      style="width: 400px"
                      @pressEnter="onAddressSearch" />
                    <a-button type="primary" icon="search" class="addr-search-btn" @click="onAddressSearch">搜索</a-button>
                  </span>
                </a-form-item>
                <!-- 内嵌地图定位面板（搜索/点选/拖拽/手输经纬度，照云贝门店编辑交互） -->
                <map-location-panel ref="mapPanel" :lat="form.lat" :lng="form.lng" :address="form.address" @change="onMapChange" />
              </div>
              <a-form-item label="包装费" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form.boxType">
                  <a-radio value="2">按商品收取</a-radio>
                  <a-radio value="1">按单收取</a-radio>
                </a-radio-group>
              </a-form-item>
              <!-- 联动：boxType=1 显示"每单收取" -->
              <a-form-item v-if="form.boxType === '1'" label="每单收取" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input-number v-model="form.boxMoney" :min="0" :precision="2" :step="1" placeholder="请输入金额" style="width: 400px" />
              </a-form-item>
              <a-form-item label="打印设置" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form.printType">
                  <a-radio value="1">订单支付后打印小票</a-radio>
                  <a-radio value="2">商家接单后打印小票</a-radio>
                </a-radio-group>
                <div class="field-tip">防止漏单，建议订单支付后自动打印小票</div>
              </a-form-item>
              <a-form-item label="外卖码" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-button type="primary" ghost size="small" @click="showTakeoutQrcode">查看二维码</a-button>
              </a-form-item>
            </a-form>
            <div class="form-footer">
              <a-button type="primary" :loading="saving" @click="handleSave('takeout')">保存</a-button>
            </div>
          </a-tab-pane>
          <!-- ============ Tab2 预约单设置（克隆云贝 #/storeoutset Tab2） ============ -->
          <a-tab-pane tab="预约单设置" key="advance">
            <a-form class="setting-form">
              <a-form-item label="预约单支持" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-checkbox-group v-model="form2.open">
                  <a-checkbox value="1">外卖</a-checkbox>
                  <a-checkbox value="2">自提</a-checkbox>
                </a-checkbox-group>
              </a-form-item>
              <!-- 联动：open 为空时隐藏其余预约项 -->
              <div v-if="form2.open.length > 0">
                <a-form-item label="休息时间支持预定" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <a-radio-group v-model="form2.restOpen">
                    <a-radio value="1">开启</a-radio>
                    <a-radio value="2">关闭</a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-form-item label="可提前预定天数" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <a-select v-model="form2.day" placeholder="请选择" style="width: 200px">
                    <a-select-option v-for="opt in dayOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="预定开始时间" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <a-select v-model="form2.startTime" placeholder="请选择" style="width: 200px">
                    <a-select-option v-for="opt in startDayOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="预订单提醒时间" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <a-select v-model="form2.remind" placeholder="请选择" style="width: 200px">
                    <a-select-option v-for="opt in remindOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="预订单间隔时间" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <a-select v-model="form2.interval" placeholder="请选择" style="width: 200px">
                    <a-select-option v-for="opt in intervalOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </a-form>
            <div class="form-footer">
              <a-button type="primary" :loading="saving" @click="handleSave('advance')">保存</a-button>
            </div>
          </a-tab-pane>
          <!-- ============ Tab3 制作时间（克隆云贝 #/storeoutset Tab3） ============ -->
          <a-tab-pane tab="制作时间" key="makeTime">
            <a-form class="setting-form">
              <a-form-item label="制作时间" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form3.open">
                  <a-radio value="1">开启</a-radio>
                  <a-radio value="2">关闭</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="制作单位" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form3.type">
                  <a-radio value="1">按单</a-radio>
                  <a-radio value="2">按件</a-radio>
                </a-radio-group>
              </a-form-item>
              <!-- 联动：type=2 按件时显示"选择单位"（商品单位下拉） -->
              <a-form-item v-show="form3.type === '2'" label="选择单位" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-select v-model="form3.unit" placeholder="请选择商品单位" style="width: 200px">
                  <a-select-option v-for="name in unitOptions" :key="name" :value="name">{{ name }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="每（单/件）制作时间" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input-number v-model="form3.time" :min="0" :precision="0" placeholder="请输入单个商品制作时间" style="width: 200px" />
                <span class="unit-text">分钟</span>
              </a-form-item>
            </a-form>
            <div class="form-footer">
              <a-button type="primary" :loading="saving" @click="handleSave('makeTime')">保存</a-button>
            </div>
          </a-tab-pane>
          <!-- ============ Tab4 配送费设置（独立设置组 delivery） ============ -->
          <a-tab-pane tab="配送费设置" key="delivery">
            <a-form class="setting-form">
              <a-form-item label="配送费类型" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form4.type">
                  <a-radio value="1">固定配送费</a-radio>
                  <a-radio value="2">按距离</a-radio>
                  <a-radio value="3">按区域</a-radio>
                </a-radio-group>
              </a-form-item>
              <!-- 固定配送费金额：云贝 delivery 组原 key 为 money（Order.php type=1 取 $store['money']） -->
              <a-form-item v-if="form4.type === '1'" label="固定配送费" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input-number v-model="form4.money" :min="0" :precision="2" placeholder="请输入固定配送费" style="width: 200px" />
                <span class="unit-text">元</span>
              </a-form-item>
              <a-form-item label="起送价" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input-number v-model="form4.startMoney" :min="0" :precision="2" placeholder="请输入起送价" style="width: 200px" />
                <span class="unit-text">元</span>
                <div class="field-tip">订单金额达不到起送价不可下单</div>
              </a-form-item>
              <!-- 联动：按距离时显示起步配送费 -->
              <a-form-item v-if="form4.type === '2'" label="起步配送费" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input-number v-model="form4.distanceStartMoney" :min="0" :precision="2" placeholder="请输入起步配送费" style="width: 200px" />
                <span class="unit-text">元</span>
              </a-form-item>
              <!-- 联动：按区域时显示区域费用数组（区域+起送价+配送费，可增删行） -->
              <a-form-item v-if="form4.type === '3'" label="区域费用" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <div v-for="(area, index) in form4.areaArr" :key="index" class="area-row">
                  <a-input v-model="area.name" placeholder="请输入区域名称" style="width: 160px" />
                  <a-input-number v-model="area.startMoney" :min="0" :precision="2" placeholder="起送价" style="width: 120px; margin-left: 10px" />
                  <a-input-number v-model="area.money" :min="0" :precision="2" placeholder="配送费" style="width: 120px; margin-left: 10px" />
                  <a class="time-del" @click="delAreaRow(index)">删除</a>
                </div>
                <a-button type="link" icon="plus" @click="addAreaRow">添加区域</a-button>
              </a-form-item>
              <a-form-item label="配送范围" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input-number v-model="form4.range" :min="0" :precision="1" placeholder="请输入配送范围" style="width: 200px" />
                <span class="unit-text">公里</span>
                <div class="field-tip">顾客定位超出配送范围不可下单</div>
              </a-form-item>
              <a-form-item label="配送方式" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form4.deliveryMode">
                  <a-radio value="1">商户自配送</a-radio>
                  <a-radio value="10">到店自提</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-form>
            <div class="form-footer">
              <a-button type="primary" :loading="saving" @click="handleSave('delivery')">保存</a-button>
            </div>
          </a-tab-pane>
        </a-tabs>
        <!-- ============ 外卖码二维码弹窗 ============ -->
        <a-modal
          title="二维码"
          :visible="qrVisible"
          :width="480"
          :footer="null"
          @cancel="qrVisible = false">
          <div class="qr-wrap">
            <!-- 占位链接：指向小程序外卖页的路由（后端 GET /api/plugin/dining/takeout-qrcode 接口为后续任务，
                 接入后此处替换为后端下发的二维码图片，内容协议与桌码 JSHOR|DTable|... 同族） -->
            <div class="qr-link-label">外卖码内容（占位链接，正式二维码待外卖码接口接入）</div>
            <div class="qr-link">{{ qrPlaceholder }}</div>
            <a-button type="primary" size="small" style="margin-top: 12px" @click="copyQrLink">复制链接</a-button>
            <div class="field-tip" style="margin-top: 12px">顾客扫码进入小程序外卖点餐页</div>
          </div>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import moment from 'moment'
import { getAction, putAction } from '@/api/manage'
import { storeOptions } from '@/api/plugin/dining'
import { mixinDevice } from '@/utils/mixin'
import JImageUpload from '@/components/jeecg/JImageUpload'
import MapLocationPanel from './MapLocationPanel'

/**
 * 外卖设置页（外卖设置/预约单设置/制作时间/配送费设置四 Tab，完全克隆云贝 #/storeoutset）
 * API 契约：GET/PUT /api/plugin/dining/store-setting/{type}，type ∈ takeout/advance/makeTime/delivery
 */
const SETTING_PREFIX = '/api/plugin/dining/store-setting'

// 外卖设置默认值（spec 1.4）
const TAKEOUT_DEFAULTS = {
  timeType: '1',
  notice: '',
  orderNotice: '',
  orderMedia: '',
  distributionSupport: ['1', '2'],
  diningType: ['1', '2'],
  reserveTelOpen: '1',
  address: '',
  lng: '',
  lat: '',
  boxType: '2',
  boxMoney: 0,
  printType: '1'
}

// 预约单设置默认值（云贝 advanceSet 同款）
const ADVANCE_DEFAULTS = {
  open: [],
  restOpen: '1',
  day: '',
  startTime: '1',
  remind: '1',
  interval: '1'
}

// 制作时间默认值（云贝 makeTime 同款）
const MAKETIME_DEFAULTS = {
  open: '2',
  type: '1',
  unit: '',
  time: 3
}

// 配送费设置默认值（spec 1.4 delivery；money 为云贝固定配送费原 key）
const DELIVERY_DEFAULTS = {
  type: '1',
  money: 0,
  startMoney: 0,
  distanceStartMoney: 0,
  areaArr: [],
  range: 0,
  deliveryMode: '1'
}

export default {
  name: 'DiningTakeoutSetting',
  mixins: [mixinDevice],
  components: { JImageUpload, MapLocationPanel },
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18, offset: 1 },
      formLabelCol: { span: 5 },
      formWrapperCol: { span: 18, offset: 1 },
      activeTab: 'takeout',
      storeOptionList: [],
      storeId: null,
      form: this.normalizeGroup(TAKEOUT_DEFAULTS),
      form2: this.normalizeGroup(ADVANCE_DEFAULTS),
      form3: Object.assign({}, MAKETIME_DEFAULTS),
      form4: this.normalizeGroup(DELIVERY_DEFAULTS),
      timeArr: [],
      saving: false,
      cardStyle: '',
      qrVisible: false,
      // 预约单下拉选项（克隆云贝 options/options2/options3/options4）
      dayOptions: [{ value: '0', label: '当日' }].concat(
        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(d => ({ value: String(d), label: d + '天' }))),
      startDayOptions: [
        { value: '0', label: '当天' },
        { value: '1', label: '明天' },
        { value: '2', label: '后天' }
      ],
      remindOptions: [
        { value: '15', label: '15分钟' },
        { value: '30', label: '30分钟' },
        { value: '45', label: '45分钟' },
        { value: '60', label: '1小时' },
        { value: '120', label: '2小时' },
        { value: '240', label: '4小时' },
        { value: '480', label: '8小时' }
      ],
      intervalOptions: [
        { value: '15', label: '15分钟' },
        { value: '30', label: '30分钟' },
        { value: '45', label: '45分钟' },
        { value: '60', label: '1小时' },
        { value: '75', label: '1小时15分钟' },
        { value: '90', label: '1小时30分钟' },
        { value: '105', label: '1小时45分钟' },
        { value: '120', label: '2小时' },
        { value: '135', label: '2小时15分钟' },
        { value: '150', label: '2小时30分钟' },
        { value: '165', label: '2小时45分钟' },
        { value: '180', label: '3小时' }
      ],
      unitOptions: []
    }
  },
  computed: {
    // 外卖码占位链接：指向小程序外卖页（正式内容由后端 takeout-qrcode 接口下发，后续任务）
    qrPlaceholder() {
      if (!this.storeId) {
        return ''
      }
      return window.location.origin + '/pages_dining/takeout/index?storeId=' + this.storeId
    }
  },
  created() {
    if (this.isDesktop()) {
      this.cardStyle = 'height:' + (document.documentElement.clientHeight - 100) + 'px'
    }
    this.loadStores()
    this.loadUnits()
  },
  methods: {
    // 数组型字段（checkbox-group 等）深拷贝默认值，避免多实例共享引用
    normalizeGroup(defaults) {
      const copy = Object.assign({}, defaults)
      Object.keys(copy).forEach(key => {
        if (Array.isArray(copy[key])) {
          copy[key] = copy[key].slice()
        }
      })
      return copy
    },
    loadStores() {
      storeOptions().then(res => {
        if (res.code === 200) {
          this.storeOptionList = res.data || []
          if (this.storeOptionList.length) {
            this.storeId = this.storeOptionList[0].id
            this.loadAll()
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 商品单位下拉（云贝 goodRender unitData 同款语义，取 jsh_unit 基本单位/副单位名称去重）
    loadUnits() {
      getAction('/unit/getAllList', { currentPage: 1, pageSize: 100 }).then(res => {
        if (res && Array.isArray(res.data)) {
          const names = []
          res.data.forEach(u => {
            [u.basicUnit, u.otherUnit, u.otherUnitTwo, u.otherUnitThree].forEach(n => {
              if (n && names.indexOf(n) === -1) {
                names.push(n)
              }
            })
          })
          this.unitOptions = names
        }
      })
    },
    onStoreChange() {
      this.loadAll()
    },
    // 切店后一次性加载四组设置（切 Tab 不重复请求）
    loadAll() {
      if (!this.storeId) {
        return
      }
      const types = [
        ['takeout', TAKEOUT_DEFAULTS, 'form'],
        ['advance', ADVANCE_DEFAULTS, 'form2'],
        ['makeTime', MAKETIME_DEFAULTS, 'form3'],
        ['delivery', DELIVERY_DEFAULTS, 'form4']
      ]
      types.forEach(item => {
        getAction(SETTING_PREFIX + '/' + item[0], { storeId: this.storeId }).then(res => {
          if (res.code === 200) {
            const merged = Object.assign(this.normalizeGroup(item[1]), res.data || {})
            // 数组字段防御：后端缺失时回落默认值
            Object.keys(item[1]).forEach(key => {
              if (Array.isArray(item[1][key])) {
                merged[key] = Array.isArray(merged[key]) ? merged[key].slice() : []
              }
            })
            this[item[2]] = merged
            if (item[0] === 'takeout') {
              this.timeArr = this.parseTimeArr(res.data)
            }
          } else {
            this.$message.warning(res.message)
          }
        })
      })
    },
    parseTimeArr(data) {
      if (data && Array.isArray(data.timeArr) && data.timeArr.length) {
        return data.timeArr.map(item => ({
          startTime: item.startTime || '00:00',
          endTime: item.endTime || '00:00',
          ciri: !!item.ciri
        }))
      }
      return []
    },
    toMoment(val) {
      return val ? moment(val, 'HH:mm') : null
    },
    // ===== 营业时间时段组（克隆云贝：最多3组，起止跨天自动标"次日"）=====
    addTimeInterval() {
      if (this.timeArr.length >= 3) {
        return
      }
      this.timeArr.push({ startTime: '00:00', endTime: '00:00', ciri: true })
    },
    delTimeInterval(index) {
      this.timeArr.splice(index, 1)
    },
    onTimeChange(item, field, val) {
      item[field] = val || '00:00'
      if (field === 'startTime') {
        item.ciri = item.startTime >= item.endTime
      } else {
        item.ciri = item.endTime <= item.startTime
      }
    },
    // ===== 区域费用行（按区域配送费）=====
    addAreaRow() {
      this.form4.areaArr.push({ name: '', startMoney: 0, money: 0 })
    },
    delAreaRow(index) {
      this.form4.areaArr.splice(index, 1)
    },
    // ===== 外卖码 =====
    showTakeoutQrcode() {
      if (!this.storeId) {
        return
      }
      this.qrVisible = true
    },
    copyQrLink() {
      const text = this.qrPlaceholder
      if (!text) {
        return
      }
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('复制成功')
    },
    // ===== 内嵌地图面板 change：同步自提地址经纬度到表单（保存链路零改动） =====
    onMapChange({ lat, lng, address }) {
      this.form.lat = lat
      this.form.lng = lng
      this.form.address = address
    },
    // ===== 自提地址栏搜索（无省市区字段，地址原样搜）→ 面板定位回填经纬度 =====
    onAddressSearch() {
      const addr = (this.form.address || '').trim()
      if (!addr) {
        this.$message.warning('请输入地址后再搜索')
        return
      }
      if (this.$refs.mapPanel) {
        this.$refs.mapPanel.doSearch(addr, addr)
      }
    },
    // ===== 保存（整组提交，成功提示"保存成功"）=====
    handleSave(type) {
      if (!this.storeId) {
        return
      }
      let body
      if (type === 'takeout') {
        if (!this.form.distributionSupport.length) {
          this.$message.warning('请选择配送支持')
          return
        }
        if (this.form.timeType === '2' && !this.timeArr.length) {
          this.$message.warning('营业时间为自定义时请添加营业时间时段')
          return
        }
        if (this.form.distributionSupport.indexOf('2') > -1) {
          if (!this.form.address || !this.form.address.trim()) {
            this.$message.warning('勾选到店自提时请输入自提地址')
            return
          }
          if (!this.form.diningType.length) {
            this.$message.warning('请选择消费方式')
            return
          }
        }
        body = Object.assign({}, this.form, {
          timeArr: this.timeArr.map(item => ({ startTime: item.startTime, endTime: item.endTime, ciri: !!item.ciri }))
        })
      } else if (type === 'advance') {
        body = Object.assign({}, this.form2)
      } else if (type === 'makeTime') {
        body = Object.assign({}, this.form3)
      } else {
        body = Object.assign({}, this.form4, {
          areaArr: this.form4.areaArr.map(area => ({ name: area.name, startMoney: area.startMoney, money: area.money }))
        })
      }
      this.saving = true
      putAction(SETTING_PREFIX + '/' + type + '?storeId=' + this.storeId, body).then(res => {
        if (res.code === 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>

<style scoped>
@import '~@assets/less/common.less';
.setting-form {
  max-width: 760px;
}
/* 地址栏+搜索按钮同行排布 */
.addr-search-row {
  display: inline-flex;
  align-items: center;
}
.addr-search-btn {
  margin-left: 8px;
}
.field-tip {
  color: #999;
  font-size: 12px;
  line-height: 16px;
  margin-top: 4px;
}
.time-rows {
  margin-top: 10px;
}
.time-row {
  margin-bottom: 10px;
}
.time-sep {
  margin: 0 10px;
}
.time-ciri {
  margin-right: 10px;
  color: #ff6b35;
}
.time-del {
  margin-left: 10px;
  font-size: 12px;
}
.area-row {
  margin-bottom: 10px;
}
.unit-text {
  margin-left: 10px;
  color: #666;
}
.form-footer {
  text-align: center;
  margin-top: 16px;
  border-top: 1px solid #e8e8e8;
  padding-top: 16px;
  max-width: 760px;
}
.qr-wrap {
  text-align: center;
  padding: 8px 0;
}
.qr-link-label {
  color: #999;
  font-size: 12px;
  margin-bottom: 8px;
}
.qr-link {
  word-break: break-all;
  color: #333;
  background: #fafafa;
  border: 1px dashed #ddd;
  border-radius: 4px;
  padding: 10px;
}
</style>
